import React from "react";

import { SpacerBlock as Value } from "@reactivated";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

/**
 * While normally icky, inline styling makes a ton of sense here. They're
 * leveraging custom properties that already exist without having to link
 * them to classes that would be created just for this purpose, and the
 * usage of these blocks are inextricably linked to these values.
 *
 * So if you are mad at the developer because you have to override a
 * height value...that's on you man
 */
export const SpacerBlock = ({ value }: Props) =>
    value.anchor ? (
        <a
            id={value.anchor}
            className={styles.root}
            style={{ height: `var(${value.height})` }}
        />
    ) : (
        <div
            aria-hidden="true"
            className={styles.root}
            style={{ height: `var(${value.height})` }}
        />
    );
